<!-- <div>
<i nz-icon nzType="database" nzTheme="twotone" class="header-icon"></i>&nbsp;<b class="header-label">State</b>
</div> -->
<pg-header
  title="State"
  ticon="database"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div>
    <div class="ds-card grid">
      @if (shwLdg) {
      <ds-loading></ds-loading>
      }
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="stateLst"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
        exportFileName="LMO Details"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblEdtBtn"
              (click)="onCellClick('edit', data)"
            >
              Edit
            </div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblDelBtn"
              (click)="onCellClick('delete', data)"
            >
              Delete
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="350"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    <div class="inptLbl">State Name</div>
    <nz-input-wrapper [nzSuffix]="inputClearTpl">
      <input
        type="text"
        nz-input
        [(ngModel)]="stateNm"
        placeholder="please enter State name"
      />
    </nz-input-wrapper>
    <ng-template #inputClearTpl
      >@if (stateNm) {
      <i
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        (click)="stateNm = null"
      ></i>
      }</ng-template
    >
    @if (shwstateEditDiv==false && shwstateDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="savemndl()">
      Submit
    </button>
    } @if (shwstateEditDiv==true && shwstateDelDiv==false) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      (click)="saveEditstate()"
    >
      Update
    </button>
    } @if (shwstateEditDiv==false && shwstateDelDiv==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure delete this ?"
      nzPopconfirmPlacement="bottom"
      (nzOnConfirm)="saveDeletestate()"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    } @if (shwSidebar) {
    <button nz-button nzType="default" class="cnclBtn" (click)="oncancel()">
      Cancel
    </button>
    }
  </nz-drawer>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
